import { render, staticRenderFns } from "./ConsultantsDataTable.vue?vue&type=template&id=67a2c68f"
import script from "./ConsultantsDataTable.vue?vue&type=script&lang=js"
export * from "./ConsultantsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports